import { TFunction } from 'i18next'

interface GetCorrectionTabTitleProps {
  correctionNo: number
  numOfCorrections: number
  t: TFunction
}

export const getCorrectionTabTitle = ({ correctionNo, t, numOfCorrections }: GetCorrectionTabTitleProps): string => {
  switch (correctionNo) {
    case 0:
      return t('vat_declarations.corrections_tab.original')
    case 1:
      /* format name like [Correction], but [Correction 1, Correction 2] */
      return numOfCorrections > 2
        ? t('vat_declarations.corrections_tab.correction', { no: correctionNo })
        : t('vat_declarations.corrections_tab.correction_single')
    default:
      return t('vat_declarations.corrections_tab.correction', { no: correctionNo })
  }
}
